/**
 * Implements a wallet watchlist star with
 * ability to change star color before adding
 */
/* eslint-disable array-bracket-newline */
import { MouseEvent, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { enums } from '@kattana-io/common';
import {
  GetWalletFromWatchlistData,
  createGetFromWalletsWatchlist,
} from '../../../selectors/watchlist';
import {
  actionAddWatchlistWallet,
  actionRemoveWatchlistWallet,
} from '../../../actions/wallet_watchlist';
import ColorPicker from '../../../components/Watchlist/ColorPicker';
import { FavStep } from '../../../components/Watchlist/WatchlistRow';

interface IWalletWatchlistStarProps {
  data: GetWalletFromWatchlistData;
}

const WalletWatchlistStar = ({ data }: IWalletWatchlistStarProps) => {
  const selectFromWatchlist = useMemo(
    () => createGetFromWalletsWatchlist(data),
    [data]
  );

  const item = useSelector(selectFromWatchlist);

  const dispatch = useDispatch();

  const [isColorPicker, setColorPicker] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [favStep, setFavStep] = useState<FavStep>(FavStep.default);
  const [tag, setTag] = useState<enums.Tag>();
  const ref = useRef<HTMLDivElement>(null);

  const actionCallback = () => {
    setLoading(false);
  };

  useEffect(() => {
    if (favStep === FavStep.color) {
      setColorPicker(true);
    }
    if (favStep === FavStep.favourite) {
      setLoading(true);
      if (tag) {
        dispatch(actionAddWatchlistWallet(data, tag, actionCallback));
        setTag(undefined);
        setFavStep(FavStep.default);
        setColorPicker(false);
      }
    }
  }, [favStep, data, tag, dispatch]);

  /**
   * Add or remove item from watchlist
   * @param ticker
   * @param inViewList
   */
  const onToggleWatchlist = (e: MouseEvent) => {
    e.stopPropagation();
    if (loading) {
      return;
    }

    if (item) {
      setLoading(true);
      dispatch(actionRemoveWatchlistWallet(item.wallet_id, actionCallback));
    } else {
      setFavStep(FavStep.color);
    }
  };

  const onUpdateTag = (tag: enums.Tag) => {
    setTag(tag);
    setFavStep(FavStep.favourite);
  };

  const rect = ref.current?.getBoundingClientRect();

  const watchlistClassName = item
    ? `overview__active_wallet__actions__item icon-star-active tag--${item?.tag}`
    : 'overview__active_wallet__actions__item icon-star';

  return (
    <>
      <div
        ref={ref}
        className={watchlistClassName}
        onClick={onToggleWatchlist}
      />
      {isColorPicker && rect && (
        <ColorPicker
          top={rect.top + 35}
          left={rect.left - 150}
          onClose={() => {
            if (favStep === FavStep.color) {
              onUpdateTag(enums.Tag.Blue);
            }
            setColorPicker(false);
          }}
          activeTag={undefined}
          onSelect={onUpdateTag}
        />
      )}
    </>
  );
};

export default WalletWatchlistStar;
